module.exports = __webpack_public_path__ + "img/shoppingBags01.de901c43.jpg";